module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Draggable', [_c('div', {
    staticClass: "drag-item",
    class: _vm.classes,
    on: {
      "click": _vm.setActive
    }
  }, [_c('div', {
    staticClass: "drag-zone"
  }, [_c('img', {
    staticClass: "drag-icon",
    attrs: {
      "src": _vm.dragIcon
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content-zone"
  }, [(_vm.size === 'small') ? _c('p', {
    staticClass: "truncate-text"
  }, [_vm._v("\n        " + _vm._s(_vm.name) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.size === 'big') ? _c('div', [_c('div', {
    staticClass: "form-container"
  }, [(_vm.item.element_type === 'confirmation') ? _c('div', [_c('div', {
    staticClass: "checkbox-container no-margin"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    }
  }), _vm._v(" "), _c('label', [_vm._v(" " + _vm._s(_vm.name) + " ")])])]) : _c('label', {
    class: _vm.labelClasses(_vm.item)
  }, [(_vm.name) ? _c('div', [_vm._v(_vm._s(_vm.name))]) : _c('div', [_c('i', [_vm._v(_vm._s(_vm.$t('ui.drag_editor.no_label')))])]), _vm._v(" "), (_vm.item.hidden) ? _c('sensual-badge', {
    attrs: {
      "color": "grey-dark",
      "text": _vm.$t('ui.drag_editor.badges.hidden')
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.item.element_type === 'text') ? _c('div', [_c('input', _vm._b({
    attrs: {
      "readonly": "",
      "type": "text"
    }
  }, 'input', _vm.textBindings, false))]) : (_vm.item.element_type === 'select') ? _c('div', [_c('select', [(_vm.defaultValueSelect) ? _c('div', [_c('option', [_vm._v(_vm._s(_vm.defaultValueSelect))])]) : _vm._e()])]) : (_vm.item.element_type === 'country_select') ? _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.defaultValueSelectCountry),
      expression: "defaultValueSelectCountry"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.defaultValueSelectCountry = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.countries), function(country) {
    return _c('option', {
      domProps: {
        "value": country['value']
      }
    }, [_vm._v(_vm._s(country['name']))])
  }), 0)]) : (_vm.item.element_type === 'textarea') ? _c('div', [_c('textarea', _vm._b({}, 'textarea', _vm.textBindings, false))]) : (_vm.item.element_type.includes('radio') && _vm.item.allowed_values.length > 0) ? _c('div', [_vm._l((_vm.shownAllowedValues), function(value) {
    return _c('div', {
      staticClass: "radio-container"
    }, [(_vm.item.show_as_buttons) ? _c('div', {
      staticClass: "custom_select"
    }, [_vm._v("\n                " + _vm._s(value.name) + "\n              ")]) : _c('div', [_c('input', {
      attrs: {
        "type": "radio"
      }
    }), _vm._v(" "), _c('label', {
      class: {
        'checked': _vm.isSelected(value)
      }
    }, [_vm._v(_vm._s(value.name))])])])
  }), _vm._v(" "), (_vm.item.allowed_values.length > 5) ? _c('div', [_c('span', {
    staticClass: "caption"
  }, [_vm._v("\n                " + _vm._s(_vm.extraAllowedValuesText) + "\n              ")])]) : _vm._e()], 2) : ((_vm.item.element_type.includes('checkbox')) && _vm.item.allowed_values.length > 0) ? _c('div', [_vm._l((_vm.shownAllowedValues), function(value) {
    return _c('div', {
      staticClass: "checkbox-container"
    }, [(_vm.item.show_as_buttons) ? _c('div', {
      staticClass: "custom_select"
    }, [_vm._v("\n                " + _vm._s(value.name) + "\n              ")]) : _c('div', [_c('input', {
      attrs: {
        "type": "checkbox"
      }
    }), _vm._v(" "), _c('label', {
      class: {
        'checked': _vm.isSelected(value)
      }
    }, [_vm._v(_vm._s(value.name))])])])
  }), _vm._v(" "), (_vm.item.allowed_values && (_vm.item.allowed_values.length > 5)) ? _c('div', [_c('span', {
    staticClass: "caption"
  }, [_vm._v("\n                " + _vm._s(_vm.extraAllowedValuesText) + "\n              ")])]) : _vm._e()], 2) : ((_vm.item.element_type === 'quantity_selection') && _vm.item.allowed_values.length > 0) ? _c('div', [_vm._l((_vm.shownAllowedValues), function(value) {
    return _c('div', [_c('select', {
      staticClass: "quantity-selection--editor"
    }, [_c('option', [_vm._v(_vm._s(value.name) + ": 0")])])])
  }), _vm._v(" "), (_vm.item.allowed_values && (_vm.item.allowed_values.length > 5)) ? _c('div', [_c('span', {
    staticClass: "caption"
  }, [_vm._v("\n                " + _vm._s(_vm.extraAllowedValuesText) + "\n              ")])]) : _vm._e()], 2) : ((_vm.item.element_type === 'date')) ? _c('div', [_c('input', {
    attrs: {
      "disabled": true,
      "type": "text"
    },
    domProps: {
      "value": "19 Aug 2019"
    }
  })]) : ((_vm.item.element_type === 'readonly')) ? _c('div', [_c('input', _vm._b({
    attrs: {
      "type": "text"
    }
  }, 'input', _vm.textBindings, false))]) : ((_vm.item.element_type === 'drawing')) ? _c('div', [_c('div', {
    staticClass: "drawing"
  })]) : _vm._e()])]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d767dd70","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/DragNDrop/EditorDragItem.vue
// module id = 2001
// module chunks = 0